import { parse, ParsedQuery } from 'query-string';
import { Location } from 'history';
import { validFiltersNames } from 'components/TopicFilters/shared';

const ALL_FILTER = 'all';

/** This method returns the filter values for all possible filters, or undefined
 * if no search parameter was found. Both are valid return types while
 * building the new query parameters for the next API call
 */
const getFiltersFromUrl = (
  location: Location<any>
): ParsedQuery<string | boolean | number> => {
  const { search } = location;
  const params: ParsedQuery<string | boolean | number> = parse(search);

  // Convert integer id filters to numbers
  Object.keys(params).forEach((key: string) => {
    const value: any = params[key];
    params[key] =
      isNaN(parseInt(value)) || key === 'genre' || key === 'customRegion'
        ? value
        : parseInt(value);
  });

  // Filter out invalid and old filters
  for (const key in params) {
    if (validFiltersNames.includes(key) && params[key] !== ALL_FILTER) continue;
    delete params[key];
  }

  return params;
};

export default getFiltersFromUrl;
